import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { ComponentInterface } from '../../../fc-core/src/component-interface';
import { Tool } from '../../../fc-core/src/toolbox/index';

var InputBase =
/*#__PURE__*/
function (_ComponentInterface) {
  _inherits(InputBase, _ComponentInterface);

  function InputBase() {
    _classCallCheck(this, InputBase);

    return _possibleConstructorReturn(this, _getPrototypeOf(InputBase).apply(this, arguments));
  }

  _createClass(InputBase, [{
    key: "configure",
    value: function configure() {
      var a = this,
          b = a.config = {},
          c = a.getFromEnv('inputOptions') || {};
      Object.assign(b, c[a.getName()]);
    }
  }, {
    key: "_checkStackLen",
    value: function _checkStackLen() {
      var a = this.getFromEnv('axesObArr'),
          b = 0;
      return a && a.forEach(function (a) {
        b += a.stack.length;
      }), b;
    }
  }, {
    key: "_raiseZoomEvents",
    value: function _raiseZoomEvents(a, b, c, d) {
      var e = this,
          f = e.getFromEnv('chart');
      a && e.fireEvent(a), b && f.fireChartInstanceEvent(b, c, d), b && f.fireChartInstanceEvent('zoomed', c, d);
    }
  }, {
    key: "getType",
    value: function getType() {
      return 'canvasInput';
    }
  }, {
    key: "enable",
    value: function enable(a) {
      var b = this;
      !0 !== b.config.enabled && (b.config.enabled = !0, a && b.fireEvent(a), b.setControl());
    }
  }, {
    key: "disable",
    value: function disable(a) {
      var b = this;
      !1 !== b.config.enabled && (b.config.enabled = !1, a && b.fireEvent(a), b.setControl());
    }
  }, {
    key: "toggle",
    value: function toggle(a) {
      this.isEnabled() ? this.disable(a) : this.enable(a);
    }
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return this.config.enabled;
    }
  }, {
    key: "setControl",
    value: function setControl() {
      var a = this.getLinkedItem('button');
      a && a.setCurrentState(this.isEnabled() ? this.config.state : 'disabled');
    }
  }, {
    key: "createButton",
    value: function createButton(a) {
      var b,
          c,
          d = this,
          e = d.getLinkedParent(),
          f = e.getFromEnv('chart'),
          g = f.getFromEnv('tool-config');

      for (var _e in b = f.getFromEnv('toolbar'), c = b.attachChild(Tool, 'tool', d.getId()), c.configure(Object.assign({}, g, {
        name: a.icon,
        tooltext: a.tooltext
      })), a.handlers) {
        a.handlers.hasOwnProperty(_e) && c.addEventListener("fc-".concat(_e), a.handlers[_e]);
      }

      return c.setLinkedItem('input', d), c;
    }
  }], [{
    key: "_getZoomInfo",
    value: function _getZoomInfo(a, b, c) {
      var d = {
        startIndex: Math.ceil(a),
        endIndex: Math.floor(b)
      };
      return c.getLabel && (d.startLabel = c.getLabel(d.startIndex).label, d.endLabel = c.getLabel(d.endIndex).label), d;
    }
  }]);

  return InputBase;
}(ComponentInterface);

export default InputBase;